import { X } from "lucide-react";

export function ValidationErrors({ errors, onClose }) {
  if (!errors || errors.length === 0) return null;
  return (
    <div style={{ padding: "10px 14px", marginBottom: 12, background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)", borderRadius: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: errors.length > 1 ? 6 : 0 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: "#ef4444" }}>Validation Error{errors.length > 1 ? "s" : ""}</span>
        {onClose && <button onClick={onClose} style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer", padding: 2 }}><X size={14} /></button>}
      </div>
      {errors.map((e, i) => <div key={i} style={{ fontSize: 11, color: "rgba(239,68,68,0.8)", paddingLeft: 8 }}>• {e}</div>)}
    </div>
  );
}
